import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import { infoLayer } from './layout';

export var lswitcher = new LayerSwitcher({
    // target:$(".layerSwitcher").get(0),
    target: $("#nav-layer-switcher").get(0),
    collapsed: false,
    reordering:false,
    extent:true,
    oninfo: function(l){
      infoLayer(l);
    }
  });

// The serach input
export var search = $('<input>').attr('placeholder','filtruj');
function filterLayers(rex, layers) {
  var found = false;
  layers.forEach(function(l){
    // Layer Group
    if (l.getLayers) {
      if (filterLayers(rex, l.getLayers().getArray())) {
        l.set('noLayer', false);
        found = true;
      } else {
        l.set('noLayer', true);
      }
    } else {
      if (rex.test(l.get('title'))) {
        l.setVisible(true);
        found = true;
      } else {
        l.setVisible(false);
      }
    }
  });
  return found;
}

search.on('keyup change', function(){
    var rex = new RegExp(search.val());
    filterLayers(rex, layers);
    // Force layer switcher redraw
    // layers[0].changed();
  });
  
  // When switcher is drawn hide/show the list item according to its visility
lswitcher.on('drawlist', function(e) {
  // Hide Layer Group with no layers visible
  if (e.layer.getLayers) {
    if (e.layer.get('noLayer')) {
      $(e.li).hide();
    } else {
      $(e.li).show();
    }
  } else {
    var rex = new RegExp(search.val());
    if (rex.test(e.layer.get('title'))) {
      $(e.li).show();
    } else {
      $(e.li).hide();
    }
  }
});